import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, Modal, ButtonGroup, Card } from 'react-bootstrap';
import { BiListOl, BiRefresh, BiDownload } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const ResumeMedis = () => {
    const [listResumeMedis, setlistResumeMedis] = useState([]);
    const [selectedData, setselectedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [showDeskripsi, setshowDeskripsi] = useState();
    const handleCloseDeskripsi = () => setshowDeskripsi(false);

    const loadInit = async () => {
        setIsLoading(true)
        try {
            // const promise1 = VedikaService.getResumeMedis($('#nocm').text());
            const promise1 = await VedikaService.getResumeMedis($('#noRegistrasi').text());
            const allPromise = await Promise.all([promise1]);
            setlistResumeMedis(allPromise[0].data.data);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        } finally {
            setIsLoading(false)
        }
    }
    const handleShowDeskripsi = (row) => {
        setselectedData(null);
        setshowDeskripsi(true);
        // loadDtDeskripsi(row)
        VedikaService.getHasilResumeMedis(row.norec, row.nocm)
            .then((res) => {
                setselectedData(res.data)
            })
    }

    const loadDtResumeMedis = () => {
        $('#dtResumeMedis').DataTable({
            data: listResumeMedis,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            columns: [
                {
                    targets: [0],
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Deskripsi' onClick={() => handleShowDeskripsi(rowData)}><BiListOl /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    data: 'tglresume',
                },
                {
                    targets: [2],
                    data: 'koderesume',
                },
                {
                    targets: [3],
                    // data: 'namadokter',
                    data: null,
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<span>{$('#dpjp').val()}</span>)
                },
                {
                    targets: [4],
                    data: 'namaruangan',
                },
            ]
        })
    }
    const loadDtDeskripsi = (res) => {
        // setTimeout(() => {
        //     $('#dtDeskripsiResumeMedis').DataTable({
        //         data: res.details,
        //         ordering: false,
        //         pageLength: 10,
        //         scrollCollapse: true,
        //         scrollY: '25vh',
        //         columns: [
        //             {
        //                 targets: [0],
        //                 data: 'namaobat',
        //             },
        //             {
        //                 targets: [1],
        //                 data: 'jumlah',
        //             },
        //             {
        //                 targets: [2],
        //                 data: 'dosis',
        //             },
        //             {
        //                 targets: [3],
        //                 data: 'frekuensi',
        //             },
        //             {
        //                 targets: [4],
        //                 data: 'carapemberian',
        //             },
        //         ]
        //     })
        // }, 2000);
    }

    useEffect(() => {
        loadDtResumeMedis();
    }, [listResumeMedis])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Resume Medis</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-warning'>
                    <div className="d-flex flex-row-reverse align-items-center bd-highlight">
                        <a href={`https://pelayanan.rsabhk.co.id/vedika/cetak/resume/${$('#norec').val()}`} style={{ textDecoration: 'none', color: 'black' }} target='_blank' download><BiDownload /> Download </a>
                    </div>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row className='mt-2'>
                <Col>
                    <Table responsive="sm" size="sm" id='dtResumeMedis' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Tgl Resume</th>
                                <th>Kode Resume</th>
                                <th>DPJP</th>
                                <th>Ruangan</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
            <Modal
                show={showDeskripsi}
                onHide={handleCloseDeskripsi}
                backdrop="static"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title>Deskripsi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Card>
                        <Card.Body>
                            {
                                selectedData ? (
                                    <Row>
                                        <Col md={3}>
                                            <p className='f7'><strong>Umur</strong><br />{selectedData.umur}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Tanggal Masuk</strong><br />{selectedData.tglregistrasi}</p>
                                            {/* <p className='f7'><strong>Tanggal Resume</strong><br />{selectedData.tglresume}</p> */}
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Tanggal Keluar/Meninggal</strong><br />{selectedData.tglpulang}</p>
                                        </Col>
                                        {/* <Col md={3}>
                                            <p className='f7'><strong>Kode Resume</strong><br />{selectedData.koderesume}</p>
                                        </Col> */}
                                        <Col md={3}>
                                            {/* <p className='f7'><strong>DPJP</strong><br />{selectedData.namadokter}</p> */}
                                            <p className='f7'><strong>DPJP</strong><br />{$('#dpjp').val()}</p>
                                        </Col>
                                        <Col md={3}>
                                            <p className='f7'><strong>Ruang Rawat Terakhir</strong><br />{selectedData.ruanganterakhir}</p>
                                        </Col>
                                        {/* <Col md={3}>
                                            <p className='f7'><strong>Nama Ruangan</strong><br />{selectedData.namaruangan}</p>
                                        </Col> */}
                                        <Col md={3}>
                                            <p className='f7'><strong>Penanggung Pembayaran</strong><br />{selectedData.kelompokpasien}</p>
                                        </Col>
                                    </Row>
                                )
                                    : null
                            }
                        </Card.Body>
                    </Card>
                    {
                        selectedData ? (
                            <>
                                <Card className='mt-2'>
                                    <Card.Body>
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Diagnosis/Masalah saat masuk</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.diagnosisawal}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Ringkasan Riwayat Penyakit</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.ringkasanriwayatpenyakit}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Pemeriksaan Fisik</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.pemeriksaanfisik}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Pemeriksaan Penunjang / Diagnostik Terpenting</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.pemeriksaanpenunjang}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Hasil Konsultasi</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.hasilkonsultasi}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Terapi / Pengobatan Selama Di Rumah Sakit</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.terapi}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Kode Diagnosis Utama</strong></h4></Col>
                                            <Col md={10}>
                                                <pre>{selectedData?.diagnosis_primer_tags
                                                    ?.map((detail) => detail.concatdiagnosa)
                                                    .join(", ")}</pre>
                                            </Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Keterangan Diagnosis Utama</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.diagnosisawal}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Kode Diagnosis Sekunder</strong></h4></Col>
                                            <Col md={10}>
                                                <pre>{selectedData?.diagnosis_sekunder_tags
                                                    ?.map((detail) => detail.concatdiagnosa)
                                                    .join(", ")}</pre>
                                            </Col>
                                        </Row>
                                        <hr className="hr" />
                                        {/* <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Keterangan Diagnosis Utama</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.diagnosisawal}</pre></Col>
                                        </Row> 
                                        <hr className="hr" /> */}
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Keterangan Diagnosis Sekunder</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.diagnosissekunder}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                         <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Kode Tindakan Prosedur</strong></h4></Col>
                                            <Col md={10}>
                                                <pre>{selectedData?.tindakan_tags
                                                    ?.map((detail) => detail.concatdiagnosatindakan)
                                                    .join(", ")}</pre>
                                            </Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Keterangan Tindakan Prosedur</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.tindakanprosedur}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Alergi (Reaksi Obat)</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.alergi}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Diet</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.diet}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Intruksi Anjuran dan Edukasi (Follow Up)</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.instruksianjuran}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Hasil Laboratorium Belum Selesai (Pending)</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.hasillab}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Kondisi Waktu Keluar</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.kondisiwaktukeluar}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Pengobatan Dilanjutkan</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'>{selectedData.pengobatandilanjutkan}</pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={2}><h4 className='text-center f7'><strong>Terapi Pulang</strong></h4></Col>
                                            <Col md={10}><pre style={{ marginBottom: '0px' }} className='f7'></pre></Col>
                                        </Row>
                                        <hr className="hr" />
                                        <Row>
                                            <Col md={12}>
                                                <Table responsive="sm" size="sm" style={{ marginTop: "-1px" }} bordered hover style={{ fontSize: 'smaller' }}>
                                                    <thead>
                                                        <tr
                                                            style={{
                                                                verticalAlign: "top",
                                                                textAlign: "center",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            <td>No.</td>
                                                            <td>Nama Obat</td>
                                                            <td>Jumlah</td>
                                                            <td>Dosis</td>
                                                            <td>Frekuensi</td>
                                                            <td>Cara Pemberian</td>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {(!selectedData?.detail || selectedData.detail.length === 0) ? (
                                                            <tr>
                                                                <td style={{ padding: "12px" }}></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        ) : (
                                                            selectedData.detail.map((resep, index) => (
                                                                <tr
                                                                    key={index}
                                                                    style={{
                                                                        verticalAlign: "top",
                                                                        textAlign: "center",
                                                                    }}
                                                                >
                                                                    <td>{index + 1}</td>
                                                                    <td>{resep.name}</td>
                                                                    <td>{resep.jumlah}</td>
                                                                    <td>{resep.dosis}</td>
                                                                    <td>{resep.frekuensi}</td>
                                                                    <td>{resep.carapemberian}</td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </>
                        ) : null
                    }
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ResumeMedis;